// Coach roster — edit values here to update the public /coaches page.

export const COACHES = [
    {
        slug: "sachin",
        // Hero
        name: "Sachin McDonnell",
        title: "Owner · Performance Coach · Sports Performance Specialist",
        photo: null, // TODO: replace with real action shot URL (1200x1500 ideal, portrait orientation)
        tagline: "20+ years coaching speed, strength, power, and long-term athletic development — from youth to professional.",

        // One-liner identity (≤ 25 words; the line under the photo)
        identity: "20+ years coaching speed, strength, power, and long-term athletic development — youth athletes to professionals, and the adults who want to keep up with them.",

        // Hard credibility
        certifications: [
            { abbr: "CSCS", full: "Certified Strength & Conditioning Specialist · National Strength & Conditioning Association" },
            { abbr: "RPR L2", full: "Reflexive Performance Reset · Level 2 Certified" },
            { abbr: "Shredmill", full: "Shredmill Specialist · advanced over-speed and resisted treadmill methodology" },
        ],

        // Degrees + institutions
        education: [
            { degree: "B.S. Exercise Science", institution: "Seattle Pacific University", years: "" },
        ],

        // What it means to be "trained like an athlete" — built in the classroom and on the floor.
        // (We intentionally do not list playing days — the credibility is the work, not the highlight reel.)
        athleticBackground: [
            "20+ years coaching athletes from youth foundational movement to professional-level performance",
            "Tens of thousands of hours on the turf and in the weight room with athletes across multiple sports",
            "Continuously studies sports science, performance technology, and AI — translating new research into measurable programs",
        ],

        // Career history
        experience: [
            { role: "Owner · Performance Coach", org: "Maximum Sports Conditioning", years: "Present" },
            { role: "Sports Performance Specialist", org: "Youth, collegiate, and professional athletes", years: "20+ years" },
        ],

        // Athletes coached — anonymized social proof
        athletesCoached: [
            "Youth athletes building foundational movement skills",
            "School-age athletes through college recruitment and beyond",
            "Collegiate and professional athletes pursuing elite performance",
            "Adults — current, former, and never-before athletes — chasing health, strength, and performance for life",
        ],

        // Coaching philosophy — most-read section
        philosophy: [
            "Sachin McDonnell is the owner of Maximum Sports Conditioning, where he specializes in speed, strength, power, and long-term athletic development. His coaching combines advanced sports science, measurable performance tracking, and individualized programming to help athletes and adults move, perform, and feel better.",
            "Maximum Sports Conditioning is known for creating training systems that help athletes stay ahead of their peers through smarter, measurable development — not just harder workouts. Over 20 years, Sachin has worked with athletes across multiple sports and levels: youth athletes building foundational movement skills, school-age athletes chasing recruitment, collegiate and professional athletes pursuing elite performance. The thread that ties it all together is long-term development, measurable progress, and sustainable training that supports performance for years to come.",
            "What also makes Maximum Sports Conditioning unique is its ability to translate elite athletic development principles to adults. Whether someone is a current athlete, former athlete, or simply wants to move better, feel stronger, and perform at a higher level, the same performance-driven systems are adapted to improve overall health, confidence, and quality of life.",
        ],

        // Specialty tags
        specialties: [
            "Speed & power development",
            "Long-term athletic development",
            "Youth foundational movement",
            "Collegiate & pro performance",
            "Adult performance for life",
            "Shredmill methodology",
        ],

        // Currently studying / on the radar
        continuingEducation: [
            "AI applied to athlete performance & programming",
            "Emerging sports-science research and tech",
        ],

        // Personality — humanises the coach without making it about playing days.
        personal: [
            "Usually listening to 90s/00s R&B or 2000s pop on the floor",
            "Studies AI, technology, and performance innovation in his off-hours",
            "Competitive board-game player",
            "Favorite superhero: Superman",
            "Believes training for high performance should be sustainable enough to do for life",
        ],

        // Testimonials — name + role + outcome
        testimonials: [
            // { name: "Jordan H.", role: "Parent of high-school athlete", text: "..." },
        ],
    },
    {
        slug: "brian",
        // Hero
        name: "Brian Lowe",
        title: "Trainer",
        photo: null, // TODO: replace with real action shot URL (1200x1500 ideal, portrait orientation)
        tagline: "Lifelong athlete teaching everyday clients and young athletes that the gym is approachable, sustainable, and life-changing.",

        // One-liner identity
        identity: "Lifelong athlete and trainer — helping everyday clients move better and feel better, while coaching athletes on sport-specific speed and strength.",

        // Hard credibility
        certifications: [
            { abbr: "ACE CPT", full: "American Council on Exercise · Certified Personal Trainer" },
            { abbr: "CPR-AED", full: "CPR & Automated External Defibrillator Certified" },
            { abbr: "RPR L1", full: "Reflexive Performance Reset · Level 1 Certified" },
        ],

        // Degrees + institutions
        education: [
            { degree: "Attended", institution: "Colorado State University", years: "" },
            { degree: "Attended", institution: "University of La Verne", years: "" },
        ],

        // Background — coaching + competitive history (no "playing days" framing for the credibility narrative)
        athleticBackground: [
            "Lifelong athlete — played soccer and football in high school, continued football at the college level",
            "3+ years coaching experience with general population and athletes",
            "In the gym daily since high school",
        ],

        // Career history
        experience: [
            { role: "Trainer", org: "Maximum Sports Conditioning", years: "Present" },
        ],

        // Athletes coached
        athletesCoached: [
            "Everyday clients chasing better movement, energy, and longevity",
            "Youth and school-age athletes building sport-specific speed and strength",
            "Adults of all experience levels — first-timers to former athletes returning to training",
        ],

        // Training philosophy — most-read section
        philosophy: [
            "\"I want to spread the idea that exercise is longevity and exercise is not as bad as you think! My goal is to help people discover that fitness can be approachable, sustainable, and life-changing.\"",
            "Brian works with everyday clients looking to feel better and move better, and also coaches athletes on sport-specific speed and strength. The thread that ties both groups together: the gym should feel like somewhere you actually want to be — not somewhere you survive.",
        ],

        // Specialty tags
        specialties: [
            "General population fitness",
            "Youth athletic development",
            "Strength training fundamentals",
            "Injury prevention",
        ],

        // Personality — humanises the coach
        personal: [
            "Huge movie lover — always down for a movie night",
            "In another life would've loved to be an actor — for now, sticks to what he knows he's good at: teaching people the beauty of the gym",
        ],

        // Testimonials
        testimonials: [
        ],
    },
];

export const findCoach = (slug) => COACHES.find((c) => c.slug === slug);
